export default __webpack_public_path__ + "static/media/trading.bf088816.svg";